import { render, staticRenderFns } from "./QuoteTemplateAvailableLabours.vue?vue&type=template&id=73f3dabc"
import script from "./QuoteTemplateAvailableLabours.vue?vue&type=script&lang=js"
export * from "./QuoteTemplateAvailableLabours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports